const NoSaigeAnswerMessage = () => (
  <div>
    <strong>No relevant procedure found.</strong>
    <br />
    <br />
    SAIGE answers questions using WHS Procedures published in Policy 2.0. Try
    rephrasing your question around a specific WHS procedure or procedural
    requirement.
    <br />
    <br />
    What to try:
    <ul>
      <li>
        Rephrase your question to reference a specific WHS procedure or safety
        topic.
      </li>
      <li>
        For local or site-specific WHS documentation, consult the appropriate
        resource, such as AUSTIN.
      </li>
      <li>
        Can&apos;t find what you need?{" "}
        <a
          href="https://issues.amazon.com/issues/create?template=c9970d52-3ccc-447d-9ead-dacdbf5349ae"
          target="_blank"
          rel="noreferrer"
        >
          Share your feedback here
        </a>{" "}
        and the team will review it for future inclusion.
      </li>
    </ul>
  </div>
);

export default NoSaigeAnswerMessage;
